import { Button } from "@mui/material";
import { grey, indigo } from "../../colors";

type ClearFiltersButtonProps = {
  height: number;
  hasUnappliedFilterChanges: boolean;
  applyFilters: () => void;
};

export default function ApplyFiltersButton({
  height,
  hasUnappliedFilterChanges,
  applyFilters,
}: ClearFiltersButtonProps) {
  return (
    <Button
      variant="contained"
      disableElevation
      disabled={!hasUnappliedFilterChanges}
      fullWidth
      onClick={applyFilters}
      sx={{
        minHeight: height,
        borderRadius: "32px",
        textTransform: "none",
        fontWeight: 500,
        display: "flex",
        justifyContent: "center",
        backgroundColor: indigo[700],
        color: "#fff",
        "&:hover": { backgroundColor: indigo[800] },
        "&.Mui-disabled": { backgroundColor: grey[100], color: grey[500] },
      }}
    >
      Apply Filters
    </Button>
  );
}
